module.exports = __webpack_public_path__ + "img/md.8fc4ea03.svg";